import { FaInstagram } from 'react-icons/fa';

import dan from '../assets/images/dani-profile.jpg';
import raq from '../assets/images/raq.jpg';

const CoupleProfile = () => {
  // Replace with actual Instagram URLs or remove if not needed
  const groomInstagram = "https://instagram.com/danielon28";
  const brideInstagram = "https://instagram.com/lady.cacahuete";

  return (
    <section className="py-16 px-4 bg-white" id="couple">
      <div className="max-w-6xl mx-auto">
        <h2 className="font-great-vibes text-4xl text-center text-rose-600 mb-12">Los protas</h2>
        
        <div className="flex flex-col md:flex-row items-center justify-center gap-12">
          {/* Groom */}
          <div className="text-center">
            <div className="rounded-full overflow-hidden border-4 border-rose-400 w-48 h-48 mx-auto mb-6 shadow-lg">
              <img 
                src={dan} 
                alt="Dani - El novio" 
                className="w-full h-full object-cover"
                loading="lazy"
              />
            </div>
            <h3 className="text-2xl font-semibold mb-2">Él</h3>
            <p className="text-gray-800 mb-1">Mister paellas</p>
            <p className="text-gray-600 mb-4">Con más color que el azafrán</p>
            
            {groomInstagram ? (
              <a 
                href={groomInstagram} 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-rose-600 hover:text-rose-700 flex items-center justify-center gap-2"
                aria-label="Instagram Mempelai Pria"
              >
                <FaInstagram /> @danielon28
              </a>
            ) : (
              <div className="text-rose-600 flex items-center justify-center gap-2">
                <FaInstagram /> @lady.cacahuete
              </div>
            )}
          </div>
          
          <div className="font-great-vibes text-4xl text-rose-600 hidden md:block">&</div>
          
          {/* Bride */}
          <div className="text-center">
            <div className="rounded-full overflow-hidden border-4 border-rose-400 w-48 h-48 mx-auto mb-6 shadow-lg">
              <img 
                src={raq}
                alt="RAquel - La novia" 
                className="w-full h-full object-cover"
                loading="lazy"
              />
            </div>
            <h3 className="text-2xl font-semibold mb-2">Ella</h3>
            <p className="text-gray-800 mb-1">Miss Marie Kondo</p>
            <p className="text-gray-600 mb-4">Diva se nace</p>
            
            {brideInstagram ? (
              <a 
                href={brideInstagram} 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-rose-600 hover:text-rose-700 flex items-center justify-center gap-2"
                aria-label="Instagram Mempelai Wanita"
              >
                <FaInstagram /> @lady.cacahuete
              </a>
            ) : (
              <div className="text-rose-600 flex items-center justify-center gap-2">
                <FaInstagram /> @lady.cacahuete
              </div>
            )}
          </div>
        </div>
      </div>
    </section>
  );
};

export default CoupleProfile;